<template>
    <div>
        <PaymentProviderTable v-if="activePaymentProviders.length > 0"
                              :active-payment-providers="activePaymentProviders"
                              :stripe-is-ready="stripeIsReady"
                              hide-header
        />
        <div v-else>
            {{ __('general.thing.not_present_yet', {thing: __('general.payment_provider')}) }}
        </div>

        <button v-if="hasInactivePaymentProvider" class="btn btn-sm btn-light-primary mt-2"
                @click="toggleShowAddPaymentProvider">
            <i class="fas fa-plus-square"/>
            {{ getButtonText }}
        </button>

        <AddPaymentProvider v-if="formVisible && hasInactivePaymentProvider"
                              :inactive-payment-providers="inactivePaymentProviders"
                              :has-stripe-account="hasStripeAccount"
                              :charges-enabled="chargesEnabled"
                              :details-submitted="detailsSubmitted"
        />
    </div>
</template>

<script>

import PaymentProviderTable from "@components/Store/Includes/PaymentProviders/PaymentProviderTable.vue";
import AddPaymentProvider from "@components/Store/Includes/PaymentProviders/AddPaymentProvider.vue";

export default {
    components: {PaymentProviderTable, AddPaymentProvider},

    props: {
        inactivePaymentProviders: Array,
        activePaymentProviders: Array,
        chargesEnabled: Boolean,
        detailsSubmitted: Boolean,
        hasStripeAccount: Boolean,
        stripeIsReady: Boolean,
    },

    data() {
        return {
            formVisible: false,
        }
    },

    methods: {
        toggleShowAddPaymentProvider() {
            this.formVisible = !this.formVisible
        },
    },

    computed: {
        getButtonText() {
            return (this.hasActivePaymentProvider && this.hasInactivePaymentProvider)
                ? this.__('sale.add_provider.multiple')
                : this.__('sale.add_provider.single')
        },

        hasActivePaymentProvider() {
            return this.activePaymentProviders.length > 0;
        },

        hasInactivePaymentProvider() {
            return this.inactivePaymentProviders.length > 0;
        }
    },
}
</script>
